import { InfoIcon } from "@phosphor-icons/react/dist/csr/Info";
import { useState } from "react";
import {
  Alert,
  AlertDescription,
  AlertTitle,
} from "@volca/ui/components/ui/alert";
import { Button } from "@volca/ui/components/ui/button";
import { Stack } from "@volca/ui/components/ui/stack";
import { matchedColumnLabel } from "@/profitability/matched-columns";
import type { ProfitabilityRun } from "@/profitability/types";

const SHOWN = 5;

export const MatchedColumnsBanner = ({
  run,
}: {
  run: Pick<ProfitabilityRun, "matched_columns">;
}) => {
  const [expanded, setExpanded] = useState(false);
  const matches = run.matched_columns ?? [];
  if (!matches.length) return null;
  const more = matches.length - SHOWN;

  return (
    <Alert
      color="information"
      className="mb-4"
      data-testid="matched-columns-banner"
    >
      <InfoIcon className="size-5" />
      <AlertTitle>Some columns had other names</AlertTitle>
      <AlertDescription>
        <Stack align="start" gap={2}>
          <span>
            This run&apos;s files name {matches.length === 1 ? "one" : "some"}{" "}
            of what the agent reads differently from the files it was built
            from. Check these figures before you rely on them.
          </span>
          <ul className="list-disc pl-5">
            {(expanded ? matches : matches.slice(0, SHOWN)).map((match) => (
              <li
                key={`${match.document_id}:${match.sheet}:${match.column ?? ""}`}
                className="[overflow-wrap:anywhere]"
              >
                {matchedColumnLabel(match)}
              </li>
            ))}
          </ul>
          {more > 0 && (
            <Button
              size="sm"
              variant="ghost"
              aria-expanded={expanded}
              onClick={() => setExpanded((open) => !open)}
            >
              {expanded ? "Show fewer" : `Show ${more} more`}
            </Button>
          )}
        </Stack>
      </AlertDescription>
    </Alert>
  );
};
